module.exports = __webpack_public_path__ + "img/bixiu02.468c5293.png";